import { Metadata } from './metadata'
import { PackageRef } from './package'

export interface FunctionPackageRef {
  packageref: PackageRef;
}

export interface FunctionSpec {
  'package': FunctionPackageRef;
}

export interface Function {
  metadata: Metadata;
  spec: FunctionSpec;
}

export class FunctionAPI {
  public static getAll (ns: string, cb: (f: Function[]) => void) {
    fetch(`/apis/fission.io/v1/namespaces/${ns}/functions`).then(
      response => response.json().then(
        f => cb(f.items)
      )
    )
  }
}
